import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-9460c72a"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "title num"
};
const _hoisted_2 = {
  key: 0,
  class: "iconfont iconhuo"
};
const _hoisted_3 = {
  class: "desc"
};
const _hoisted_4 = {
  class: /*#__PURE__*/_normalizeClass({
    icon: true
  })
};
const _hoisted_5 = {
  key: 0,
  class: "iconfont iconCheckmark-01 mr13 font12"
};
const _hoisted_6 = {
  key: 1,
  class: "iconfont iconnewscanj-01 mr13 font12 icon-crosss"
};
const _hoisted_7 = {
  class: "down pointer br4"
};
const _hoisted_8 = {
  class: "fl ml14"
};

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconxiazai- fr"
}, null, -1));

const _hoisted_10 = {
  class: "downUl"
};

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconwindows mr10 font12"
}, null, -1));

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Windows", -1));

const _hoisted_13 = [_hoisted_11, _hoisted_12];

const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconpingguo mr10 font12"
}, null, -1));

const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "MAC", -1));

const _hoisted_16 = [_hoisted_14, _hoisted_15];

const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconlinux mr10 font12"
}, null, -1));

const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Linux", -1));

const _hoisted_19 = [_hoisted_17, _hoisted_18];
const _hoisted_20 = {
  class: "ep-item"
};

const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1));

const _hoisted_22 = {
  class: "icon"
};
const _hoisted_23 = {
  key: 0,
  class: "iconfont iconCheckmark-01 mr13 font12"
};
const _hoisted_24 = {
  key: 1,
  class: "iconfont iconnewscanj-01 mr13 font12 icon-crosss"
};
const _hoisted_25 = {
  class: "btns-sec",
  style: {
    "margin-top": "30px"
  }
};
const _hoisted_26 = {
  class: "mb20 mt18 sale-download"
};
const _hoisted_27 = {
  class: "down pointer br4"
};
const _hoisted_28 = {
  class: "fl ml14"
};

const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconxiazai- fr"
}, null, -1));

const _hoisted_30 = {
  class: "downUl"
};

const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconwindows mr10 font12"
}, null, -1));

const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Windows", -1));

const _hoisted_33 = [_hoisted_31, _hoisted_32];

const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconpingguo mr10 font12"
}, null, -1));

const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "MAC", -1));

const _hoisted_36 = [_hoisted_34, _hoisted_35];

const _hoisted_37 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconlinux mr10 font12"
}, null, -1));

const _hoisted_38 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Linux", -1));

const _hoisted_39 = [_hoisted_37, _hoisted_38];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_collapse_transition = _resolveComponent("el-collapse-transition");

  const _component_el_tag = _resolveComponent("el-tag");

  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["editionBox", {
      'en-item': _ctx.lang == 'en'
    }])
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("span", {
    class: _normalizeClass({
      smallTitle: _ctx.lang === 'en' && _ctx.keys === 3
    })
  }, [_createTextVNode(_toDisplayString(_ctx.title), 1), _ctx.keys == 1 ? (_openBlock(), _createElementBlock("i", _hoisted_2)) : _createCommentVNode("", true)], 2)]), _createElementVNode("div", {
    class: _normalizeClass(['outerBox', _ctx.keys == 2 ? 'borderOuter' : ''])
  }, [_createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.desc), 1), _renderSlot(_ctx.$slots, "price", {}, undefined, true), _ctx.keys != 3 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass(["feature", {
      'zh-fea': _ctx.lang != 'en'
    }])
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.feature, (item, key) => {
    return _openBlock(), _createElementBlock("div", {
      key: key,
      class: _normalizeClass({
        spanOp: item.cross,
        featureList: true
      })
    }, [_createElementVNode("span", _hoisted_4, [!item.cross ? (_openBlock(), _createElementBlock("i", _hoisted_5)) : (_openBlock(), _createElementBlock("i", _hoisted_6))]), _createElementVNode("span", {
      class: _normalizeClass({
        blueSpan: item.blue
      })
    }, _toDisplayString(_ctx.$t(`featureList["${item.name}"]`)), 3)], 2);
  }), 128))], 2)) : _createCommentVNode("", true), _ctx.keys != 3 ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: _normalizeClass(["mb20 mt18 height34 sale-download", {
      'com-zh-down': _ctx.lang != 'en'
    }])
  }, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", {
    class: "width134 height34 lh34 colorFFF",
    onClick: _cache[0] || (_cache[0] = _withModifiers($event => _ctx.setShow(_ctx.keys), ["stop"]))
  }, [_createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("Download")), 1), _hoisted_9]), _createVNode(_component_el_collapse_transition, null, {
    default: _withCtx(() => [_withDirectives(_createElementVNode("div", _hoisted_10, [_createElementVNode("div", {
      class: "downLi al height38 lh38 pl16",
      onClick: _cache[1] || (_cache[1] = _withModifiers($event => _ctx.down(_ctx.downData.id, 0), ["stop"]))
    }, _hoisted_13), _createElementVNode("div", {
      class: "downLi al height38 lh38 pl16",
      onClick: _cache[2] || (_cache[2] = _withModifiers($event => _ctx.down(_ctx.downData.id, 1), ["stop"]))
    }, _hoisted_16), _createElementVNode("div", {
      class: "downLi al height38 lh38 pl16",
      onClick: _cache[3] || (_cache[3] = _withModifiers($event => _ctx.down(_ctx.downData.id, 2), ["stop"]))
    }, _hoisted_19)], 512), [[_vShow, _ctx.show]])]),
    _: 1
  })])], 2)) : _createCommentVNode("", true), _ctx.keys == 3 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 2
  }, [_createElementVNode("div", _hoisted_20, [_hoisted_21, _createElementVNode("div", {
    class: _normalizeClass(["feature", {
      'zh-fea': _ctx.lang != 'en',
      enkeys3: _ctx.lang === 'en' && _ctx.keys === 3
    }])
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.feature, (item, key) => {
    return _openBlock(), _createElementBlock("div", {
      key: key,
      class: "featureList"
    }, [_createElementVNode("span", _hoisted_22, [!item.cross ? (_openBlock(), _createElementBlock("i", _hoisted_23)) : (_openBlock(), _createElementBlock("i", _hoisted_24))]), _createElementVNode("span", {
      class: _normalizeClass({
        blueSpan: item.blue
      })
    }, _toDisplayString(_ctx.$t(`featureList["${item.name}"]`)), 3), item.increment ? (_openBlock(), _createBlock(_component_el_tag, {
      key: 0,
      size: "small",
      style: {
        "margin-left": "5px"
      }
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("value-added")), 1)]),
      _: 1
    })) : _createCommentVNode("", true)]);
  }), 128))], 2)]), _createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createElementVNode("div", {
    class: "width134 height34 lh34 colorFFF",
    onClick: _cache[4] || (_cache[4] = _withModifiers($event => _ctx.setShow(_ctx.keys), ["stop"]))
  }, [_createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$t("Download")), 1), _hoisted_29]), _createVNode(_component_el_collapse_transition, null, {
    default: _withCtx(() => [_withDirectives(_createElementVNode("div", _hoisted_30, [_createElementVNode("div", {
      class: "downLi al height38 lh38 pl16",
      onClick: _cache[5] || (_cache[5] = _withModifiers($event => _ctx.down(_ctx.downData.id, 0), ["stop"]))
    }, _hoisted_33), _createElementVNode("div", {
      class: "downLi al height38 lh38 pl16",
      onClick: _cache[6] || (_cache[6] = _withModifiers($event => _ctx.down(_ctx.downData.id, 1), ["stop"]))
    }, _hoisted_36), _createElementVNode("div", {
      class: "downLi al height38 lh38 pl16",
      onClick: _cache[7] || (_cache[7] = _withModifiers($event => _ctx.down(_ctx.downData.id, 2), ["stop"]))
    }, _hoisted_39)], 512), [[_vShow, _ctx.show]])]),
    _: 1
  })])])])], 64)) : _createCommentVNode("", true)], 2)], 2);
}